import visaRequirementAPI from "@/api/visaRequirement";
import types from "../types";
import { baseURL } from "@/api/http-common";

// initial state
const state = {
  ids: [],
  entities: [],
};

const getVisaRequirements = (state) =>
  state.ids.map((id) => state.entities[id]);

// getters
const getters = {
  [types.getters.visaRequirements]: getVisaRequirements,
  [types.getters.visaRequirement]: (state) => (visaRequirementID) =>
    state.entities[visaRequirementID],
  [types.getters.visaRequirementByContactID]: (state) => (contactID) => {
    const visaRequirement = Object.values(state.entities).find(
      (visaRequirement) => visaRequirement.contactID === contactID,
    );
    // console.log("visaRequirement:", visaRequirement)
    return visaRequirement;
  },
};

// actions
const actions = {
  [types.actions.updateVisaRequirementField](
    { commit },
    { visaRequirementID, fieldName, value },
  ) {
    commit(types.mutations.updateVisaRequirementField, {
      visaRequirementID,
      fieldName,
      value,
    });
  },
  [types.actions.updateVisaRequirementsRemote](
    { commit },
    { visaRequirements, showLoader = true },
  ) {
    const changedVisaRequirements = visaRequirements.filter(
      (visaRequirement) => visaRequirement.isDirty,
    );
    if (!changedVisaRequirements.length) {
      return Promise.resolve();
    }

    showLoader && commit(types.mutations.setIsLoading, { isLoading: true });

    return visaRequirementAPI
      .updateVisaRequirements(visaRequirements)
      .then((res) => {
        commit(types.mutations.resetContactsDirtyFlag);
        return res;
      })
      .finally(() => {
        showLoader &&
          commit(types.mutations.setIsLoading, { isLoading: false });
      });
  },
};

// mutations
const mutations = {
  [types.mutations.setVisaRequirements](state, visaRequirements) {
    state.ids = visaRequirements.map(
      (visaRequirement) => visaRequirement.visaRequirementID,
    );
    state.entities = visaRequirements.reduce((accumulate, visaRequirement) => {
      if (visaRequirement.file && visaRequirement.file.url) {
        visaRequirement.file.url = `${baseURL}/${visaRequirement.file.url}`;
      }

      accumulate[visaRequirement.visaRequirementID] = visaRequirement;
      return accumulate;
    }, {});
  },
  [types.mutations.updateVisaRequirementField](
    state,
    { visaRequirementID, fieldName, value },
  ) {
    state.entities[visaRequirementID][fieldName] = value;
    state.entities[visaRequirementID].isDirty = true;
  },
  [types.mutations.updateVisaRequirementEntity](state, { visaRequirement }) {
    if (visaRequirement.file && visaRequirement.file.url) {
      visaRequirement.file.url = `${baseURL}/${visaRequirement.file.url}`;
    }

    state.entities[visaRequirement.visaRequirementID] = visaRequirement;
  },
  [types.mutations.resetVisaRequirementsDirtyFlag](state) {
    getVisaRequirements(state).forEach((entity) => (entity.isDirty = false));
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/visaRequirement.js